/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IGameData, IInitData, IServerData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";
import {TombstoneGameMode} from "../gamemode/TombstoneGameMode";
import {ITombstoneGameData, ITombstoneServerData} from "./data/ITombstoneServerData";

export class TombstoneServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }

    public parseDoReelNudge(rawData:ITombstoneGameData):boolean[] {
        return rawData.doReelNudge.concat();
    }

    public parseExtraSymbolsOnTop(rawData:ITombstoneGameData):string[][] {
        this.filterBonusSymbols(rawData.extraSymbolsOnTop);
        this.filterWildSymbols(rawData.extraSymbolsOnTop);

        return ServerDataParser.parseStackedSymbolsInReels(rawData.extraSymbolsOnTop);
    }

    public parseSuperFreespinTriggeredThisSpin(rawData:ITombstoneServerData):boolean {
        return rawData.superFreespinTriggeredThisSpin != null ? rawData.superFreespinTriggeredThisSpin : false;
    }

    public parseReels(rawData:IServerData):string[][] {
        if("isRestoreState" in rawData) {
            this.filterInitRestoredStickyWild(<IInitData>rawData);
        }

        this.filterBonusSymbols(rawData.reels);
        this.filterWildSymbols(rawData.reels);

        return super.parseReels(rawData);
    }

    public parseReelsEnteringFreespin(rawData:IGameData):string[][] | undefined {
        if(rawData.reelsEnteringFreespin != undefined) {
            this.filterBonusSymbols(rawData.reelsEnteringFreespin);
            this.filterWildSymbols(rawData.reelsEnteringFreespin);
        }

        return super.parseReelsEnteringFreespin(rawData);
    }

    private filterBonusSymbols(reels:string[][]) {
        reels[0].forEach((symName:string, index:number) => {
            if(symName === "B") {
                reels[0][index] = "B1";
            }
        });
        reels[4].forEach((symName:string, index:number) => {
            if(symName === "B") {
                reels[4][index] = "B2";
            }
        });
    }

    private filterWildSymbols(reels:string[][]) {
        for(let i:number = 1; i < 4; i++) {
            reels[i].forEach((symName:string, index:number) => {
                if(symName === "W") {
                    reels[i][index] = `W${i}`;
                }
            });
        }
    }

    private filterInitRestoredStickyWild(rawData:IInitData):void {
        if(!rawData.isRestoreState) {
            return;
        }

        if(rawData.nextMode != GameMode.RESPIN && rawData.nextMode != TombstoneGameMode.SUPER_FREESPIN) {
            return;
        }

        if(rawData.overlayWilds == null) {
            return;
        }

        // Replace the reel if there is sticky wild.
        for(let i:number = 1; i < 4; i++) {
            if(rawData.overlayWilds[i][0]) {
                if(rawData.reels[i][0] === "W") {
                    rawData.reels[i][0] = "M1"; // temp hack
                }
                rawData.reels[i][1] = "W";
                rawData.reels[i][2] = "W";
                rawData.reels[i][3] = "W";
                if(rawData.reels[i][4] === "W") {
                    rawData.reels[i][4] = "M2"; // temp hack
                }
            }
        }
    }

    public parseOverlayWildsBeforeSpin(rawData:ITombstoneServerData):boolean[][] {
        if(rawData.overlayWildsBeforeSpin == null) {
            return ArrayHelper.initArrayWithValues(5, (reelIndex:number) => {
                return ArrayHelper.initArrayWithValues(3, () => false);
            });
        } else {
            return rawData.overlayWildsBeforeSpin;
        }
    }

    public parseBonusSpinsLeft(rawData:ITombstoneServerData):number {
        return rawData.bonusSpinsLeft;
    }

    public parseMultiplierOnReel(rawData:ITombstoneServerData):number[] {
        if(rawData.multiplierOnReel == null) {
            return ArrayHelper.initArrayWithValues(5, () => 0);
        }

        return rawData.multiplierOnReel;
    }

    public parseBonusTriggeredThisSpin(rawData:ITombstoneGameData):boolean {
        return rawData.bonusTriggeredThisSpin;
    }

    public parseBonusPositions(rawData:ITombstoneGameData):number[] {
        return rawData.bonusPositions;
    }

    public parseNumberOfBonusSpinsPlayed(rawData:ITombstoneGameData):number {
        return rawData.numberOfBonusSpinsPlayed;
    }
}